import { type AppConfig } from '../../../../types';

export const appFramework = (
	config: AppConfig,
): {
	'app:framework:name': string;
	'app:framework:version': string;
} | null => {
	if (!config.framework) {
		return null;
	}
	return {
		'app:framework:name': config.framework.name,
		'app:framework:version': config.framework.version,
	};
};
